<template>
  <div>
    <b-form-group label="نام سرفصل" label-for="add-topic-title">
      <validation-provider
        #default="{ errors }"
        name="title"
        vid="title"
        rules="required"
      >
        <b-form-input
          autocomplete="on"
          id="add-topic-title"
          v-model="title"
          name="add-topic-title"
          :state="errors.length > 0 ? false : null"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group label="انتخاب جلسه" label-for="add-topic-sessions">
      <validation-provider #default="{ errors }" name="sessions" vid="sessions">
        <select-box
          v-model="sessions"
          searchable
          multiple
          label="text"
          url="session"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <draggable
      v-model="sessions"
      class="list-group list-group-flush cursor-move"
      tag="ul"
      group="a"
    >
      <b-list-group-item
        v-for="(session, index) in sessions"
        :key="index"
        tag="li"
        class="px-0"
      >
        <session-row
          :session="session"
          v-model="newSessions[index]"
          :topicSessions="sessions"
          @removeSession="removeSession"
          :sessionIndex="index"
        />
      </b-list-group-item>
    </draggable>
  </div>
</template>

<script>
import {
  BListGroupItem,
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
} from "bootstrap-vue";
import draggable from "vuedraggable";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import SessionRow from "./SessionRow.vue";
export default {
  props: {
    topic: {
      Object: Object,
      default: () => {},
    },
  },
  directives: {
    Ripple,
  },
  components: {
    draggable,
    BListGroupItem,
    BButton,
    SelectBox,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BBadge,
    SessionRow,
  },
  data() {
    return {
      required,
      title: "",
      key: "",
      sessions: [],
      newSessions: [],
    };
  },
  methods: {
    removeSession(id) {
      this.sessions.splice(
        this.sessions.findIndex((session) => session.id == id),
        1
      );
    },
  },
  created() {
    Object.keys(this.topic).map((key) => {
      this[key] = this.topic[key];
    });
  },
  watch: {
    sessions(val) {
      if (val.length) {
        let index = -1;
        val.forEach((session) => {
          index = val.findIndex((checkSession) => {
            return session !== checkSession && session.id == checkSession.id;
          });

          index > -1 && this.sessions.splice(index, 1);
        });
      }
      if (val.length < this.newSessions.length) {
        if (val.length) {
          this.newSessions = this.newSessions.filter(
            (newSession) =>
              val.findIndex((session) => {
                return session.id == newSession.id;
              }) > -1
          );
        } else {
          this.newSessions = [];
        }
      }
    },
    topic(val) {
      Object.keys(val).map((key) => {
        this[key] = val[key];
      });
    },
    newTopic(val) {
      Object.keys(val).map((key) => {
        this.topic[key] = this[key];
      });
      this.$emit("input", val);
    },
  },
  computed: {
    newTopic() {
      return {
        title: this.title,
        key: this.key,
        sessions: this.newSessions,
      };
    },
  },
};
</script>
